// removed by extract-text-webpack-plugin
module.exports = {"resize":"resize"};


//////////////////
// WEBPACK FOOTER
// ./~/wasabiD/Sass/Layout/resize.scss
// module id = 245
// module chunks = 0